import { HttpContext } from '@angular/common/http';
import { REQUEST_OPTIONS, RequestOptionsAnyType } from '@data-access';
import { ERROR_FALLBACK, SILENT_ERROR } from '../interceptors/refresh-token.interceptor';

export const REQUEST_OPTIONS_WITH_SILENT_ERROR: RequestOptionsAnyType = {
  observe: 'body',
  reportProgress: false,
  options: {
    context: new HttpContext().set(SILENT_ERROR, true),
  },
};

/** A backend code with no `errors.responseErrors` text toasts `fallbackKey` instead of the generic error. */
export function requestOptionsWithErrorFallback(fallbackKey: string): RequestOptionsAnyType {
  return {
    ...REQUEST_OPTIONS,
    options: {
      ...REQUEST_OPTIONS.options,
      context: new HttpContext().set(ERROR_FALLBACK, fallbackKey),
    },
  };
}
